import $ from 'jquery';

export default function tabsDirective(context=document.body) {
	const $context = $(context);

	$context.find('[sw-tab-index]').each(function() {
        // console.log('tab', this);
        const _this = this;
        const $this = $(_this);

        const index = $this.attr('sw-tab-index');

        $this.hover(function(){
            $('[sw-tab-index]').removeClass('is-selected');
            $('[sw-tab-content-index]').removeClass('is-selected');

            if(!$this.hasClass('is-selected')) {
                $this.addClass('is-selected');
                $('[sw-tab-content-index="'+ index +'"].tab-content').addClass('is-selected');   
            }
        });
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/tabs.js